export const endPoints = {
  HOUSE: '/v1/mobile/contract/discount/house',
  MONTH: '/v1/mobile/contract/discount/month',
  EMPLOYEE: '/v1/mobile/contract/discount/employee'
};
